import { render, staticRenderFns } from "./PageInformation.vue?vue&type=template&id=4a87d0d5&"
import script from "./PageInformation.vue?vue&type=script&lang=js&"
export * from "./PageInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports